import { useMutation } from '@tanstack/react-query';

import { WorkingHoursExceptionsFormSchemaValues } from 'src/features/workingHoursExceptions/utils/formSchema';
import { WorkingHoursException } from 'src/features/workingHoursExceptions/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/site/:siteId/site-working-hours-exception/`;

type MutationFnType = typeof mutationFn;

interface DTO extends WorkingHoursExceptionsFormSchemaValues {
    siteId: string;
    parkingId: string;
}
const mutationFn = ({ siteId, parkingId, ...data }: DTO): Promise<WorkingHoursException> => {
    return axios.post(formatResourcePath(RESOURCE, { siteId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateWorkingHoursException };
